import { LayoutDashboard, Terminal, Clock, Shield, Settings, Trophy, Music, Bell, Gift, Monitor, ListTodo, Hash, Package, Timer, Hourglass, Bot, Layers, Sparkles, Network, Volume2, History, Dices, Coffee, Activity, Users, } from "lucide-react";
export const HOME_ITEM = {
    to: "/",
    icon: LayoutDashboard,
    label: "Start",
    keywords: "dashboard übersicht home bot status uptime live chat",
};
// Grouped by what you want to do, not by how it is built. Entries that stand
// for several pages (Live-Tools, Verlauf, Casino) link to the first one; the
// rest is reachable through the tab bar in the layout (see sections.ts).
export const NAV_GROUPS = [
    {
        label: "Im Stream",
        items: [
            { to: "/alerts", icon: Bell, label: "Alerts", keywords: "benachrichtigung popup follow follower sub abo resub giftsub bits cheer raid hype train tts sprachausgabe layout position animation" },
            { to: "/sounds", icon: Volume2, label: "Sounds & Videos", keywords: "sound alert !sound audio mp3 mp4 video random lautstärke wunschliste gewünscht" },
            { to: "/channelpoints", icon: Gift, label: "Kanalpunkte", keywords: "channel points belohnung reward einlösen redemption twitch" },
            { to: "/overlay", icon: Monitor, label: "Szenen & Overlays", keywords: "obs browser source browserquelle url link starting soon be right back brb offline in-game hud get the clip aktuelles spiel umfrage poll vorhersage prediction player" },
            { to: "/stopwatch", icon: Timer, label: "Live-Tools", keywords: "stoppuhr stopwatch" },
        ],
    },
    {
        label: "Chat",
        items: [
            { to: "/commands", icon: Terminal, label: "Befehle", keywords: "commands kommandos trigger antwort alias !befehle" },
            { to: "/timers", icon: Clock, label: "Timer", keywords: "automatische nachricht wiederholen intervall" },
            { to: "/counters", icon: Hash, label: "Zähler", keywords: "counter deaths tode wins" },
            { to: "/moderation", icon: Shield, label: "Moderation", keywords: "spam filter banned words verbotene wörter timeout ban links caps emotes action log" },
            { to: "/chatlogs", icon: History, label: "Verlauf", keywords: "chatlog chat-log nachrichten suchen" },
        ],
    },
    {
        label: "Zuschauer",
        items: [
            { to: "/points", icon: Trophy, label: "Punkte", keywords: "points leaderboard rangliste watchtime" },
            { to: "/requests", icon: ListTodo, label: "Wünsche", keywords: "requests zuschauerwünsche vorschläge" },
        ],
    },
    {
        label: "Add-ons",
        items: [
            { to: "/casino-settings", icon: Dices, label: "Casino", keywords: "crisino features minigames gambling jackpot pets lucky hour daily challenge story mode" },
            { to: "/lootbox", icon: Package, label: "Lootbox", keywords: "items inventar seltenheit rarity" },
            { to: "/songrequests", icon: Music, label: "Song Requests", keywords: "musik songs queue warteschlange player !sr" },
            { to: "/orgchart", icon: Network, label: "Organigramm", keywords: "orgchart team kasten" },
        ],
    },
    {
        label: "Community",
        items: [
            { to: "/discord", icon: Bot, label: "Discord", keywords: "bot live-meldung stream online offline rollen rules zusammenfassung" },
            { to: "/kofi", icon: Coffee, label: "Ko-fi", keywords: "kofi spenden donation webhook token" },
        ],
    },
    {
        label: "Einstellungen",
        items: [
            { to: "/settings", icon: Settings, label: "Einstellungen", keywords: "settings kanal editoren account mods berechtigung login" },
            { to: "/claude/", icon: Sparkles, label: "Claude Console", external: true, keywords: "ki ai terminal" },
        ],
    },
];
/** Section tabs that have no menu entry of their own, so the search finds them too */
export const TAB_PAGES = [
    { to: "/countdown", icon: Hourglass, label: "Countdown", group: "Live-Tools", keywords: "timer runterzählen" },
    { to: "/sandbox", icon: Layers, label: "Sandbox", group: "Live-Tools", keywords: "live overlay zeichnen text bilder" },
    { to: "/events", icon: Activity, label: "Event-Historie", group: "Verlauf", keywords: "events follows subs raids" },
    { to: "/admin/casino", icon: Users, label: "Casino · Spieler & Punkte", group: "Add-ons", keywords: "spieler admin punkte vergeben" },
];
